import { render, staticRenderFns } from "./clientGroupCreate.vue?vue&type=template&id=6163ac14&scoped=true&"
import script from "./clientGroupCreate.vue?vue&type=script&lang=ts&"
export * from "./clientGroupCreate.vue?vue&type=script&lang=ts&"
import style0 from "./clientGroupCreate.vue?vue&type=style&index=0&id=6163ac14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6163ac14",
  null
  
)

export default component.exports